import { createAction } from 'typesafe-actions';

import { EContractType } from 'shared/types/filters/contractType';

export const changeContractAction = createAction(
  'filters/contractChanged',
  (event: React.ChangeEvent<HTMLInputElement>) => Number(event.target.value),
)<EContractType>();
